import React from "react";
import AdminPanelDom from "../domains/adminPanel/adminPanelDom";
import FaturaDomain from "../domains/FaturaDomain/FaturaDomain"
import NewFaturaDomain from "../domains/FaturaDomain/NewFaturaDomain";

class SuperAdminFatura extends React.Component {
  render() {
    return (
      <AdminPanelDom
     component={()=>
        <NewFaturaDomain />
        }
        {...this.props}
      />
    );
  }
}

export default SuperAdminFatura;